
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.openers = document.querySelectorAll(`[data-modal="#${this.modalContent.getAttribute('id').replace('Info','')}"]`);
      this.overlay = this.querySelector('.quickadd-modal-overlay')
      this.openers.forEach((opener) => opener.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }))

      this.overlay.addEventListener("click", () => {
        console.log("click")
        this.hide()
        this.overlay.style.display = "none"
      })

    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      this.openers.forEach((opener) => {
        console.log(opener)
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        opener.querySelector('.icon-cart').classList.add('hidden');
      })


      fetch(this.openers[0].getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('.product .product');

          // move pictos
          this.pictos = this.productElement.querySelector('.picto_tags')
          this.productElement.querySelector('.product__title').appendChild(this.pictos);

          // remove provenance modal
          if (this.productElement.querySelector("#PopupModal")) {
            this.productElement.querySelector("#PopupModal").remove()
          }

          this.modalContent.style.display = "flex"
          this.overlay.style.display = "block"
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);


          this.cartDrawer = document.querySelector('cart-drawer')
          this.cartDrawer.querySelector('.cart-drawer-close').click()
          this.cartIcon = document.querySelector('cart-icon')
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          var splide = new Splide( `splider-component .splide-${this.modalContent.getAttribute('id') .replace('QuickAddInfo-', '')}`,{
              pagination: false,
              arrows: false,
              perPage: 1,
              padding: '15rem',
              breakpoints: {
                  990: {
                    perPage: 1,
                  },
                }
            } );
          splide.mount();
          super.show(opener);

          this.addToCarts = document.querySelectorAll('.quick-add-modal .product-form__submit')
          this.addToCarts.forEach((addToCart) => { addToCart.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.form = this.querySelector('form');
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify({
              ...JSON.parse(serializeForm(this.form)),
              sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                this.hide()
                this.overlay.style.display = "none"
                this.cartIcon.openDrawer(e)
                this.cartDrawer.renderContents(response);
              })
            });
          })
        })
        .finally(() => {
          this.openers.forEach((opener) => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.icon-cart').classList.remove('hidden');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          })
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }
    
    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
